<template>
    <div>
        <buttonlist
                @help="help"
                @opentable="opentable"
                @search="search"
                @reflash="reflash"
                @exps="exps"
                ref="SetBtn"
        ></buttonlist>
        <el-table
                id="xpane-0"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:0px"
                :header-cell-style="$limits.headerClass"
                ref="singleTable"
        >
            <el-table-column type="selection"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Customer_Name" :label="$t('getapi[6134]')" width="150"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Customer_ID" :label="$t('getapi[12479]')" width="90"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Customer_Person" :label="$t('getapi[6403]')" width="90"></el-table-column>
            <el-table-column show-overflow-tooltip prop="PaymentDay" :label="$t('getapi[8496]')" width="90"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Country" :label="$t('getapi[8339]')" width="90"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Rec_C00" :label="$t('getapi[12480]')" align="right" width="90"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Rec_M01" :label="$t('getapi[7600]')" align="right" width="90"></el-table-column>
            <el-table-column label="1">
                <el-table-column prop="Day_M01" :label="$t('getapi[7600]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_R01" :label="$t('getapi[12338]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_C01" :label="$t('getapi[12483]')" align="right" width="60"></el-table-column>
            </el-table-column>
            <el-table-column label="2">
                <el-table-column prop="Day_M02" :label="$t('getapi[7600]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_R02" :label="$t('getapi[12338]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_C02" :label="$t('getapi[12483]')" align="right" width="60"></el-table-column>
            </el-table-column>
            <el-table-column label="3">
                <el-table-column prop="Day_M03" :label="$t('getapi[7600]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_R03" :label="$t('getapi[12338]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_C03" :label="$t('getapi[12483]')" align="right" width="60"></el-table-column>
            </el-table-column>
            <el-table-column label="4">
                <el-table-column prop="Day_M04" :label="$t('getapi[7600]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_R04" :label="$t('getapi[12338]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_C04" :label="$t('getapi[12483]')" align="right" width="60"></el-table-column>
            </el-table-column>
            <el-table-column label="5">
                <el-table-column prop="Day_M05" :label="$t('getapi[7600]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_R05" :label="$t('getapi[12338]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_C05" :label="$t('getapi[12483]')" align="right" width="60"></el-table-column>
            </el-table-column>
            <el-table-column label="6">
                <el-table-column prop="Day_M06" :label="$t('getapi[7600]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_R06" :label="$t('getapi[12338]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_C06" :label="$t('getapi[12483]')" align="right" width="60"></el-table-column>
            </el-table-column>
            <el-table-column label="7">
                <el-table-column prop="Day_M07" :label="$t('getapi[7600]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_R07" :label="$t('getapi[12338]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_C07" :label="$t('getapi[12483]')" align="right" width="60"></el-table-column>
            </el-table-column>
            <el-table-column label="8">
                <el-table-column prop="Day_M08" :label="$t('getapi[7600]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_R08" :label="$t('getapi[12338]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_C08" :label="$t('getapi[12483]')" align="right" width="60"></el-table-column>
            </el-table-column>
            <el-table-column label="9">
                <el-table-column prop="Day_M09" :label="$t('getapi[7600]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_R09" :label="$t('getapi[12338]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_C09" :label="$t('getapi[12483]')" align="right" width="60"></el-table-column>
            </el-table-column>
            <el-table-column label="10">
                <el-table-column prop="Day_M10" :label="$t('getapi[7600]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_R10" :label="$t('getapi[12338]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_C10" :label="$t('getapi[12483]')" align="right" width="60"></el-table-column>
            </el-table-column>
            <el-table-column label="11">
                <el-table-column prop="Day_M11" :label="$t('getapi[7600]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_R11" :label="$t('getapi[12338]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_C11" :label="$t('getapi[12483]')" align="right" width="60"></el-table-column>
            </el-table-column>
            <el-table-column label="12">
                <el-table-column prop="Day_M12" :label="$t('getapi[7600]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_R12" :label="$t('getapi[12338]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_C12" :label="$t('getapi[12483]')" align="right" width="60"></el-table-column>
            </el-table-column>
            <el-table-column label="13">
                <el-table-column prop="Day_M13" :label="$t('getapi[7600]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_R13" :label="$t('getapi[12338]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_C13" :label="$t('getapi[12483]')" align="right" width="60"></el-table-column>
            </el-table-column>
            <el-table-column label="14">
                <el-table-column prop="Day_M14" :label="$t('getapi[7600]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_R14" :label="$t('getapi[12338]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_C14" :label="$t('getapi[12483]')" align="right" width="60"></el-table-column>
            </el-table-column>
            <el-table-column label="15">
                <el-table-column prop="Day_M15" :label="$t('getapi[7600]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_R15" :label="$t('getapi[12338]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_C15" :label="$t('getapi[12483]')" align="right" width="60"></el-table-column>
            </el-table-column>
            <el-table-column label="16">
                <el-table-column prop="Day_M16" :label="$t('getapi[7600]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_R16" :label="$t('getapi[12338]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_C16" :label="$t('getapi[12483]')" align="right" width="60"></el-table-column>
            </el-table-column>
            <el-table-column label="17">
                <el-table-column prop="Day_M17" :label="$t('getapi[7600]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_R17" :label="$t('getapi[12338]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_C17" :label="$t('getapi[12483]')" align="right" width="60"></el-table-column>
            </el-table-column>
            <el-table-column label="18">
                <el-table-column prop="Day_M18" :label="$t('getapi[7600]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_R18" :label="$t('getapi[12338]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_C18" :label="$t('getapi[12483]')" align="right" width="60"></el-table-column>
            </el-table-column>
            <el-table-column label="19">
                <el-table-column prop="Day_M19" :label="$t('getapi[7600]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_R19" :label="$t('getapi[12338]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_C19" :label="$t('getapi[12483]')" align="right" width="60"></el-table-column>
            </el-table-column>
            <el-table-column label="20">
                <el-table-column prop="Day_M20" :label="$t('getapi[7600]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_R20" :label="$t('getapi[12338]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_C20" :label="$t('getapi[12483]')" align="right" width="60"></el-table-column>
            </el-table-column>
            <el-table-column label="21">
                <el-table-column prop="Day_M21" :label="$t('getapi[7600]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_R21" :label="$t('getapi[12338]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_C21" :label="$t('getapi[12483]')" align="right" width="60"></el-table-column>
            </el-table-column>
            <el-table-column label="22">
                <el-table-column prop="Day_M22" :label="$t('getapi[7600]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_R22" :label="$t('getapi[12338]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_C22" :label="$t('getapi[12483]')" align="right" width="60"></el-table-column>
            </el-table-column>
            <el-table-column label="23">
                <el-table-column prop="Day_M23" :label="$t('getapi[7600]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_R23" :label="$t('getapi[12338]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_C23" :label="$t('getapi[12483]')" align="right" width="60"></el-table-column>
            </el-table-column>
            <el-table-column label="24">
                <el-table-column prop="Day_M24" :label="$t('getapi[7600]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_R24" :label="$t('getapi[12338]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_C24" :label="$t('getapi[12483]')" align="right" width="60"></el-table-column>
            </el-table-column>
            <el-table-column label="25">
                <el-table-column prop="Day_M25" :label="$t('getapi[7600]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_R25" :label="$t('getapi[12338]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_C25" :label="$t('getapi[12483]')" align="right" width="60"></el-table-column>
            </el-table-column>
            <el-table-column label="26">
                <el-table-column prop="Day_M26" :label="$t('getapi[7600]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_R26" :label="$t('getapi[12338]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_C26" :label="$t('getapi[12483]')" align="right" width="60"></el-table-column>
            </el-table-column>
            <el-table-column label="27">
                <el-table-column prop="Day_M27" :label="$t('getapi[7600]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_R27" :label="$t('getapi[12338]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_C27" :label="$t('getapi[12483]')" align="right" width="60"></el-table-column>
            </el-table-column>
            <el-table-column label="28">
                <el-table-column prop="Day_M28" :label="$t('getapi[7600]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_R28" :label="$t('getapi[12338]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_C28" :label="$t('getapi[12483]')" align="right" width="60"></el-table-column>
            </el-table-column>
            <el-table-column label="29">
                <el-table-column prop="Day_M29" :label="$t('getapi[7600]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_R29" :label="$t('getapi[12338]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_C29" :label="$t('getapi[12483]')" align="right" width="60"></el-table-column>
            </el-table-column>
            <el-table-column label="30">
                <el-table-column prop="Day_M30" :label="$t('getapi[7600]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_R30" :label="$t('getapi[12338]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_C30" :label="$t('getapi[12483]')" align="right" width="60"></el-table-column>
            </el-table-column>
            <el-table-column label="31">
                <el-table-column prop="Day_M31" :label="$t('getapi[7600]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_R31" :label="$t('getapi[12338]')" align="right" width="60"></el-table-column>
                <el-table-column prop="Day_C31" :label="$t('getapi[12483]')" align="right" width="60"></el-table-column>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="Mouth_SumMoney" :label="$t('getapi[12482]')" align="right" width="90"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Rec_Rate" :label="$t('getapi[12481]')" align="right" width="90"></el-table-column>
        </el-table>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="SalMonthCountViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[12307]')" queryData="SalMonthCountViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
        name:'3_finrecdaytab',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('3_finrecdaytab'), // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function() {
            let that = this;
            that.colsort();
            that.userData = sessionStorage.getItem('userData');
            that.PlanTypeArray = Array.methods.getPlanType();
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('SalMonthCountViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[12478]"),this.$t("getapi[3846]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('3_finrecdaytab',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'SalMonthCountViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Finance/FrmSaleInvoice/FinRecDaysTab', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/Finance/FrmSaleInvoice/FinRecDaysTabExportToExecl', parm, function(res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "SalMonthCountViewInfo",
                    fromname: that.$t('getapi[12307]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)*/
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
